<template>
  <div class="container where-to-buy-company">
    <div class="company-container">
      <div>
          <companies-map style="width: 50%" :companies="[company]"/>
      </div>
      <div>
          <div v-if="vendor === 'wellfar' && company.vehicle_types?.length" class="company-specs">
          <span>{{ $t('specialization') }}</span>
          <div>
              <i v-for="vt in vehicleTypes.filter(x => company.vehicle_types.includes(x.id))"
                  class="svg-icon" :class="vt.icon_class"></i>
          </div>
          </div>
          <div v-if="company.address">
          <i class="svg-icon location"></i>
          {{ company.address }}
          </div>
          <template v-if="company.phone">
          <div class="company-phone" v-for="phone in company.phone.split(';')">
              <i class="svg-icon phone"></i>
              <a :href="'tel:' + phone">{{ phone | formatPhone}}</a>
          </div>
          </template>
          <div class="company-email" v-if="company.email">
          <i class="svg-icon email"></i>
          <a :href="'mailto:' + company.email">{{ company.email}}</a>
          </div>
          <div class="company-site" v-if="company.site_b2b">
          <i class="svg-icon site"></i>
          <a :href="company.site_b2b" target="_blank">{{ company.site_b2b }}</a>
          </div>
          <div class="company-site" v-if="company.site_b2c">
          <i class="svg-icon site"></i>
          <a :href="company.site_b2c" target="_blank">{{ company.site_b2c }}</a>
          </div>
      </div>
    </div>
  </div>
</template>


<script>
import {rememberExpiresMixin, whereToBuyCompanyPageMixin} from '@/mixins';
import CompaniesMap from '@/components/where-to-buy/companies-map';

export default {
  components: {CompaniesMap},
  props: ['company', 'dbConfig', 'vehicleTypes'],
  mixins: [rememberExpiresMixin, whereToBuyCompanyPageMixin],
  computed: {
    vendor(){
      return process.env.VENDOR
    },
  },
}
</script>
